import classNames from 'classnames';

export interface NotificationBadgeProps {
  visible: boolean;
}

export function NotificationBadge({ visible }: NotificationBadgeProps) {
  if (!visible) return null;

  return <div className={classNames('absolute right-0 top-0 h-2 w-2 rounded-full bg-brand')} />;
}
